var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTutorial02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1087_36003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2673 6H3.73267C2.77574 6 2 6.77574 2 7.73267V23.7599C2 24.7168 2.77574 25.4926 3.73267 25.4926H28.2673C29.2243 25.4926 30 24.7168 30 23.7599V7.73267C30 6.77574 29.2243 6 28.2673 6Z",
    fill: "#B9DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 11.6832H30",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6931 16.7079H6.29706C5.73247 16.7079 5.27478 17.1656 5.27478 17.7302V21.1262C5.27478 21.6908 5.73247 22.1485 6.29706 22.1485H9.6931C10.2577 22.1485 10.7154 21.6908 10.7154 21.1262V17.7302C10.7154 17.1656 10.2577 16.7079 9.6931 16.7079Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1087_36003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 19.4926,
    fill: "white",
    transform: "translate(2 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTutorial02);
export default __webpack_public_path__ + "static/media/icon_tutorial_02.17745403aeb2aaadcb8bbe78feb53301.svg";
export { ForwardRef as ReactComponent };